import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Button, Card, CardActions, CardContent, CardHeader, CardMedia, Collapse, Divider, IconButton, styled, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useState } from "react";
import image from '..//images/digest_animation2.gif';

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));


const BiosynthesisCard = () => {

    const [expanded, setExpanded] = useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    return (
        <Card style={{ minHeight: "680px", display: 'flex', justifyContent: 'space-between', flexGrow: "1", flexDirection: 'column', alignContent: 'stretch', position:"relative" }} elevation={5} >
            <Box>
                <CardHeader
                    title="Plant Cell Wall Biosynthesis and Degradation"
                />
                <Divider />
            </Box>
            
            <CardMedia sx={{
                padding: "1em", width: "60%",
                margin: "0 auto",
            }}
                component="img"
                image={image}
                alt=" Schematic representation of the structure of the substrate in the model.
                (a) Several cellulose microfibrils embedded in a matrix of hemicellulose reinforced by lignin. 
                (b) Side-view of the top 50 nm of a single cellulose microfibril made of 36 polymers, and part 
                of the surrounding matrix showing the relative arrangement of the hemicellulose and lignin 
                polymers as well as gaps. In (a) and (b), polymer types are color-coded (cellulose: dark gray; 
                hemicellulose: light gray; lignin: black). (c) Top-down view of the structure shown in (b). The 
                core enclosed by the dotted line is composed of 36 polymers of cellulose (black crosses), and its
                 structure follows that used by Ding et al. The positions in the two outer layers (gray crosses) 
                 can each either be hemicellulose or lignin polymers."
            />
            <CardContent align="left">
                Climate change directly impacts on plants, and specifically the plant cell wall is concerned. 
                Thus, we are interested in understanding how the structure and composition of the latter impacts on 
                the ability of the xylem to transport water under drought stress conditions. 
                Besides, the plant cell wall of leftover wastes generated by agriculture contains energy under the form of sugar polymers, 
                that can be extracted as monomers, during saccharification.
                 In the context of energy shortage, we 
                tend to predict the recalcitrance of lignocellulose to saccharification, by taking into consideration its structure and composition.
            </CardContent>
            <Box>
            <Divider/>
                <CardActions >
                <Button variant="contained" component={Link} to="/publications">
                        Publications
                    </Button>

                </CardActions>
            </Box>

        
        </Card >
    );
};

export default BiosynthesisCard;